import { render } from "./Login.vue?vue&type=template&id=002bd70f&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=002bd70f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002bd70f"]])

export default __exports__